import { render, staticRenderFns } from "./BetaChip.vue?vue&type=template&id=c88f04b8"
import script from "./BetaChip.vue?vue&type=script&lang=ts"
export * from "./BetaChip.vue?vue&type=script&lang=ts"
import style0 from "./BetaChip.vue?vue&type=style&index=0&id=c88f04b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports